import { Component, OnInit } from '@angular/core';
import { LoginModel } from '../models/login.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-cover-login',
  templateUrl: './auth-cover-login.component.html',
  styleUrls: ['./auth-cover-login.component.css']
})

/**
 * Auth Cover-Login Component
 */
export class AuthCoverLoginComponent implements OnInit {
  year = new Date().getFullYear()
  model:LoginModel;
  form:FormGroup;
  constructor(private fb:FormBuilder,private authService:AuthService,public router:Router) { }
  createLoginForm():FormGroup{
    return this.fb.group({
      email:[this.model.email,Validators.required],
      password:[this.model.password,Validators.required],
      stayLogin:[this.model.stayLogin],
    })
  }
  ngOnInit(): void {
    this.model = new LoginModel();
    this.form = this.createLoginForm();
  }
  submit(){
    this.model = this.form.getRawValue();
    console.log('model',this.model)
    this.authService.login(this.model)
    .subscribe(data => {
      if (data === true) {
         this.router.navigate(['']);
         }
         else{
         }
      },
      error => {
    
       });
  }
}
